var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcompanhar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-opacity:0;opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "acompanhar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xCDcones_Outline",
    "data-name": "\\xCDcones Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acompanhar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.41,37.59,36.23,33.4a8,8,0,1,0-2.57,3.09l3.93,3.93a2,2,0,0,0,2.83-2.83ZM29,34a4,4,0,1,1,4-4A4,4,0,0,1,29,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,33H13.5A1.38,1.38,0,0,1,12,31.78V9.22A1.4,1.4,0,0,1,13.5,8H22v4a3,3,0,0,0,3,3h4v2a2,2,0,0,0,4,0V11a2,2,0,0,0-.72-1.54l-6-5A2,2,0,0,0,25,4H13.5A5.37,5.37,0,0,0,8,9.22V31.78A5.37,5.37,0,0,0,13.5,37H16a2,2,0,0,0,0-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcompanhar);
export default __webpack_public_path__ + "static/media/acompanhar.b6d45dbf3623e73e2892bb83ec0c9758.svg";
export { ForwardRef as ReactComponent };